var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widgetwrapper"},[_c('div',{style:({ color: _vm.color, fontSize: _vm.fontSize + 'px' }),attrs:{"width":"100%","height":"100%"}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }